import { Routes } from "react-router-dom";
import usePublicRoutes from "./shared/routes/public/usePublicRoutes";
import usePrivateRoutes from "./shared/routes/private/usePrivateRoutes";

const LubricationModuleApp = () => {
  const PublicRoutes = usePublicRoutes();
  const PrivateRoutes = usePrivateRoutes();

  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      {PublicRoutes}

      {/* PRIVATE ROUTES */}
      {PrivateRoutes}
    </Routes>
  );
};

export default LubricationModuleApp;
